var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectCreated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72.178,
    height: 96.238,
    viewBox: "0 0 72.178 96.238",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3546",
    "data-name": "Group 3546",
    transform: "translate(-682.538 -626)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5089",
    "data-name": "Path 5089",
    d: "M169.576,33.6a4.481,4.481,0,0,0-4.374,4.374v74.366a2.214,2.214,0,0,0,.649,1.538l15.31,15.31a2.213,2.213,0,0,0,1.538.649h50.34a4.478,4.478,0,0,0,4.341-4.374V37.975a4.478,4.478,0,0,0-4.341-4.374Zm0,4.374h63.43v87.49H185.98v-12.03a4.475,4.475,0,0,0-4.374-4.374h-12.03Zm44.565,4.341a2.208,2.208,0,0,0-1.265.649L195.823,60.019,189.706,53.9a2.187,2.187,0,1,0-3.076,3.11l7.655,7.655a2.272,2.272,0,0,0,3.076,0l18.591-18.591a2.187,2.187,0,0,0-1.811-3.759ZM180.307,71.879a2.19,2.19,0,1,0,.205,4.374h42.651a2.187,2.187,0,1,0,0-4.374H180.307Zm0,14.217a2.19,2.19,0,1,0,.205,4.374h42.651a2.187,2.187,0,1,0,0-4.374H180.307Zm0,14.217a2.19,2.19,0,1,0,.205,4.374h42.651a2.187,2.187,0,1,0,0-4.374H180.307Zm-8.715,13.122h10.013v10.013Z",
    transform: "translate(517.336 592.398)",
    fill: "#2a9e00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectCreated);
export default __webpack_public_path__ + "static/media/project_created.bec9cfd5498f3abce542bbf3e6d844dc.svg";
export { ForwardRef as ReactComponent };